import { Request } from '~src/httpClient/serverApi/requests/Request';

import { IContentRelayPlanDetail, ISelectionQuery } from '../types/ISelectionQuery';

/**
 * Parameters for the VizPortal `createPlan` Web Client method
 * (WebClientContentMobilityAppService.createPlan). Identity and site come from the authenticated
 * actor, never the payload.
 */
export interface ICreateContentRelayPlanParams {
  name: string;
  description?: string;
  selectionQueries: ISelectionQuery[];
}

export class CreateContentRelayPlanRequest extends Request<ICreateContentRelayPlanParams, IContentRelayPlanDetail> {
  constructor(params: ICreateContentRelayPlanParams) {
    super('createPlan', params);
  }
}
